import React from 'react';
import {Spinner} from 'react-bootstrap';
import {CBCButton} from 'shared/helpers';
import styled from 'styled-components';

interface PayButtonProps {
    text: string;
    disabled: boolean;
    isLoading: boolean;
    hide: boolean;
    type?: 'button' | 'submit' | 'reset';
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    iconName?: string;
}

export const PayButton = ({
    text,
    disabled,
    isLoading,
    hide,
    onClick,
    type = 'button',
    iconName,
}: PayButtonProps) => {
    if (hide) {
        return null;
    }

    return (
        <Button
            iconName={iconName}
            disabled={disabled}
            type={type}
            onClick={onClick}
            className="job-button button-blue">
            {isLoading ? (
                <MiniSpinner animation="border" role="loading">
                    <span className="visually-hidden">Loading...</span>
                </MiniSpinner>
            ) : (
                text
            )}
        </Button>
    );
};

const Button = styled(CBCButton)`
    width: 100%;
    font-weight: 500;
    cursor: pointer;

    &:active {
        transform: translateY(2px);
    }
`;

const MiniSpinner = styled(Spinner)`
    width: 19px;
    height: 19px;
    border-width: medium;
`;
